var magicStyles = [".digit[data-v-7e89f65c]{flex-basis:calc((100% - ((var(--magic-code-entry-digits,4) - 1) * 8px)) * (1 / var(--magic-code-entry-digits,4)) + 0px);flex-grow:0}"];

export default magicStyles;
